/* Folio eBooks theme: small, dependency-free. Everything works without JavaScript except the theme toggle and live variant price. */
(function () {
  var root = document.documentElement;
  root.classList.add('js');

  // Policy pages (privacy, refund, terms...): show the Readore name instead of the old store name.
  var brand = window.ReadoreBrand;
  var policy = document.querySelector('.shopify-policy__container');
  if (brand && brand.from && brand.to && brand.from !== brand.to && policy) {
    var esc = brand.from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp(esc, 'gi');
    var walker = document.createTreeWalker(policy, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) { if (re.test(node.nodeValue)) { re.lastIndex = 0; node.nodeValue = node.nodeValue.replace(re, brand.to); } re.lastIndex = 0; }
  }

  // Menu drawer (top-left button).
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-menu-open]');
  if (drawer && openBtn) {
    function setDrawer(open) {
      drawer.hidden = !open;
      openBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) { var c = drawer.querySelector('.drawer__close'); if (c) c.focus(); } else { openBtn.focus(); }
    }
    openBtn.addEventListener('click', function () { setDrawer(drawer.hidden); });
    drawer.querySelectorAll('[data-menu-close]').forEach(function (el) { el.addEventListener('click', function () { setDrawer(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) setDrawer(false); });
  }

  // Light/dark mode toggle (preference is remembered on this device only).
  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    function label() { var dark = root.dataset.theme === 'dark'; btn.setAttribute('aria-pressed', String(dark)); btn.textContent = dark ? btn.dataset.light : btn.dataset.dark; }
    label();
    btn.addEventListener('click', function () {
      var next = root.dataset.theme === 'dark' ? 'light' : 'dark';
      root.dataset.theme = next;
      try { localStorage.setItem('theme', next); } catch (e) {}
      label();
    });
  });

  // Product page: changing the format (variant) updates the price shown and the add-to-cart state.
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    var price = document.querySelector('[data-price-now]');
    var was = document.querySelector('[data-price-was]');
    var submit = form.querySelector('[data-add-to-cart]');
    function apply() {
      var o = select.options[select.selectedIndex];
      if (price) price.textContent = o.dataset.price;
      if (was) { was.textContent = o.dataset.compare || ''; was.hidden = !o.dataset.compare; }
      var now = form.querySelector('[data-order-now]'); if (now) now.disabled = o.dataset.available !== 'true';
      if (submit) { var ok = o.dataset.available === 'true'; submit.disabled = !ok; submit.textContent = ok ? submit.dataset.add : submit.dataset.soldOut; }
      var url = new URL(window.location.href); url.searchParams.set('variant', o.value); window.history.replaceState({}, '', url);
    }
    select.addEventListener('change', apply);
  });

  // Cards: "Add to cart" adds without leaving the page and shows a confirmation. "Order now" is a normal submit (goes to checkout).
  var toastEl = document.querySelector('[data-toast]'), toastTimer;
  function toast(message, withLink) {
    if (!toastEl) return;
    toastEl.textContent = message;
    if (withLink) { var a = document.createElement('a'); a.href = toastEl.dataset.cartUrl; a.textContent = toastEl.dataset.view; toastEl.appendChild(a); }
    toastEl.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.hidden = true; }, 5000);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute || !form.hasAttribute('data-ajax-add')) return;
    if (e.submitter && e.submitter.name === 'return_to') return;
    e.preventDefault();
    var btn = e.submitter, root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || ''); return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.badge-count').forEach(function (b) { b.textContent = cart.item_count; b.setAttribute('aria-label', cart.item_count + ' items'); });
        toast(toastEl.dataset.added + ' ', true);
      })
      .catch(function (err) { toast(err.message || toastEl.dataset.error, false); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  // Cart page: quantity changes save automatically (no "Update cart" button needed).
  (function () {
    var cartRoot = function () { return document.querySelector('[data-cart-root]'); };
    if (!cartRoot()) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var timers = {}, chain = Promise.resolve();
    function status(msg) { var s = document.querySelector('[data-cart-status]'); if (s) s.textContent = msg; }
    function busy(on) { var r = cartRoot(); if (r) r.setAttribute('aria-busy', on ? 'true' : 'false'); }
    function setBadges(count) { document.querySelectorAll('.badge-count').forEach(function (b) { b.textContent = count; b.setAttribute('aria-label', count + ' items'); }); }
    function refresh() {
      return fetch(base + 'cart', { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-root]');
        if (next && cartRoot()) cartRoot().innerHTML = next.innerHTML;
        return fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setBadges(c.item_count); });
      });
    }
    function change(key, qty) {
      chain = chain.then(function () {
        busy(true);
        return fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
          .then(function () { return refresh(); })
          .then(function () { status(document.body.dataset.cartUpdated || 'Cart updated'); })
          .catch(function () { return refresh().then(function () { status(document.body.dataset.cartError || 'Could not update your cart.'); }); })
          .then(function () { busy(false); });
      });
    }
    function schedule(input, qty) {
      var key = input.dataset.lineKey; if (!key) return;
      qty = Math.max(0, Math.min(99, parseInt(qty, 10) || 0));
      input.value = qty;
      clearTimeout(timers[key]);
      timers[key] = setTimeout(function () { change(key, qty); }, 450);
    }
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]'), rm = e.target.closest('[data-cart-remove]');
      if (minus || plus) {
        var input = (minus || plus).parentNode.querySelector('[data-qty-input]');
        schedule(input, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
      } else if (rm) {
        e.preventDefault(); change(rm.dataset.lineKey, 0);
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-input]')) schedule(e.target, e.target.value);
      if (e.target.matches('[data-cart-note]')) {
        fetch(base + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-qty-input]')) { e.preventDefault(); schedule(e.target, e.target.value); } });
  })();
})();
